import { environment } from '../../environments/environment';
export const MENU = JSON.parse(environment.navBar.menuSetting);
export const NAV_ROLE_FILTER = JSON.parse(environment.navBar.roleFilter);
export const SIDEBAR = JSON.parse(environment.sideBar);
export const IMPORT = JSON.parse(environment.import);
export const UPLOAD_SIZE_CHART = JSON.parse(environment.uploadSizeChart);
export const MANAGE_INSPECTIONS = JSON.parse(environment.manageInspections);
export const CLIENT_SKIPPED_INSPECTIONS = JSON.parse(environment.clientSkippedInspections);
export const CLIENT_INSPECTIONS = JSON.parse(environment.clientInspection);
export const CREATE_INSPECTIONS = JSON.parse(environment.createInspections);
export const SKIPPED_INSPECTION = JSON.parse(environment.skippedInspections);
export const AQL_REPORT = JSON.parse(environment.aqlReport);
export const DEFAULT_DIVISION = environment.defaultDivision;
function parseStringArrayConfig(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter((item) => item !== '');
  }
  if (typeof value !== 'string') {
    return [];
  }
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return [];
  }
  try {
    const parsedValue: unknown = JSON.parse(trimmedValue);
    return Array.isArray(parsedValue)
      ? parsedValue.map((item) => String(item).trim()).filter((item) => item !== '')
      : [];
  } catch {
    return [];
  }
}
export const ASSIGN_CONTROL_POINTS_ROLE_IDS: string[] = parseStringArrayConfig(
  environment?.['assignControlPointsRoles']
);
export const CLIENT = {
  MATALAN: environment.clientName.toLowerCase() === 'matalan',
  RIVERISLAND: environment.clientName.toLowerCase() === 'riverisland',
  SUPERDRY: environment.clientName.toLowerCase() === 'superdry',
  TWC: environment.clientName.toLowerCase() === 'twc',
  DEMO: environment.clientName.toLowerCase() === 'demo',
  PEPKOR: environment.clientName.toLowerCase() === 'pepkor',
};

export const APP_ROUTES = {
  MAIN: 'main',
  AUTH: {
    CALLBACK: 'auth/callback',
    NOT_APPROVED: 'not-approved',
  },
  CLIENT: {
    INSPECTIONS: 'inspections',
    SKIPPED_INSPECTIONS: 'skipped-inspections',
    PURCHASE_ORDERS: 'purchase-orders',
  },
  REPORTING: {
    SUPPLIER_ANALYSIS: 'Supplier-Analysis',
    DEFECT_ANALYSIS: 'Defect-Analysis',
    YOUR_REPORTS: 'Your-Reports',
    REPORTS: 'reports', // FOR SML DEV / UAT
    INSIGHTS: 'Insights',
    INSPECTION_ACTIVITY: 'Inspection-Activity',
    PRODUCTION_LINE_ANALYSIS: 'Production-Line-Analysis',
    QUALITY_REPORTS: 'Quality-Reports',
    INSPECTOR_PERFORMANCE: 'Inspector-Performance',
  },

  PLANNING: {
    BASE: 'planning',
    IMPORT: 'import',
    PRODUCT: 'product',
    TABLE: 'table',
    PO_SELECTION: 'po-selection',
    SKIPPED_INSPECTIONS: 'skipped-inspections',
    MANAGE_INSPECTIONS: 'manage-inspections',
    PACKAGING: 'packaging',
    INSPECTION: 'inspections',
    INSPECTION_DETAIL: 'inspections/:id',
    INSPECTION_REPORT_DOWNLOAD: 'inspections/:id/report/download',
    DOWNLOADS: 'downloads',
    COMPLIANCE_DETAIL: 'compliance-detail/:id',
  },

  USER: {
    BASE: 'user',
    LIST: 'users',
    ADD: 'add-user',
  },
};

export const PLAN_V2_URL = `https://planning.${environment.clientName}.${(environment as any).domain || 'cliv.info'}`;
const USER_BASE = '/user';
const PLANNING_BASE = '/planning';

export function generateUserRoute(path: string): string {
  return `${USER_BASE}/${path}`;
}

export function generatePlanningRoute(path: string): string {
  return `${PLANNING_BASE}/${path}`;
}

export function inspectionReportDownloadUrl(
  inspectionId: string,
  type: 'full' | 'summary' = 'full'
): string {
  const path = generatePlanningRoute(
    APP_ROUTES.PLANNING.INSPECTION_REPORT_DOWNLOAD.replace(':id', inspectionId)
  );
  if (type === 'full') {
    return path;
  }
  return `${path}?type=${type}`;
}

const REPORTING_PAGES = [
  APP_ROUTES.REPORTING.SUPPLIER_ANALYSIS,
  APP_ROUTES.REPORTING.DEFECT_ANALYSIS,
  APP_ROUTES.REPORTING.YOUR_REPORTS,
  APP_ROUTES.REPORTING.REPORTS,
  APP_ROUTES.REPORTING.INSIGHTS,
  APP_ROUTES.REPORTING.INSPECTION_ACTIVITY,
  APP_ROUTES.REPORTING.PRODUCTION_LINE_ANALYSIS,
  APP_ROUTES.REPORTING.QUALITY_REPORTS,
];
const INSPECTOR_PERFORMANCE_PAGES = [APP_ROUTES.REPORTING.INSPECTOR_PERFORMANCE];

const CUSTOMER_PAGES = [
  APP_ROUTES.REPORTING.SUPPLIER_ANALYSIS,
  APP_ROUTES.REPORTING.DEFECT_ANALYSIS,
  APP_ROUTES.REPORTING.YOUR_REPORTS,
  APP_ROUTES.REPORTING.REPORTS,
  APP_ROUTES.REPORTING.INSIGHTS,
  APP_ROUTES.REPORTING.PRODUCTION_LINE_ANALYSIS,
  APP_ROUTES.REPORTING.QUALITY_REPORTS,
];

const CLIENT_PAGES = [
  APP_ROUTES.CLIENT.INSPECTIONS,
  APP_ROUTES.CLIENT.SKIPPED_INSPECTIONS,
  APP_ROUTES.CLIENT.PURCHASE_ORDERS,
];

export const EXCLUDED_DOMAINS = ['twoeightone', 'demo'];

export const ROLES = {
  SYSTEM_ADMIN: '8EC4C6AE-A070-4A37-ACA2-9DF61B8844C8',
  REGIONAL_DIRECTOR: '6F8FF70E-9377-4C54-B5DF-0B9A2B2E6E75',
  INSPECTOR: '4024AD67-867B-4B78-A17D-37F9CD7229AE',
  ANALYST: 'A0189E34-57FD-4448-86B2-FFD184B9B3F5',
  PLANNER: '939A37A5-3FE0-460B-964B-67C29287D492',
  QC_INSPECTOR: '4024AD67-867B-4B78-A17D-37F9CD7229AE',
  TECHNICIAN: 'C81BA03D-9F78-43AA-B8B3-8FD262C499E2',
  REVIEWER: '84E075D2-8529-464C-B46C-42CCBC78B8F6',
  BOOKING_REQUESTOR: '40D00BD0-C67E-45C7-9CCC-00CEE0BBB9F8',
  USER_ADMIN: '496B45D8-B036-4877-BD67-6353096E0FDF',
  DECISION_EDITOR: '8026882A-E570-45F0-8F1F-4B35B41494B8',
  CUSTOMER: '604EA866-22A8-4D2E-A352-1FE839F87A10',
};

export const ALLOWED_ROLES_WITHOUT_LOCATION = [
  ROLES.SYSTEM_ADMIN,
  ROLES.TECHNICIAN,
  ROLES.ANALYST,
  ROLES.CUSTOMER,
  ROLES.USER_ADMIN,
  ROLES.DECISION_EDITOR,
];

/** Matches backend APP_CONSTANTS.ROLES_WITH_LOCATION_REQUIRED */
export const ROLES_WITH_LOCATION_REQUIRED = [
  ROLES.REGIONAL_DIRECTOR,
  ROLES.PLANNER,
  ROLES.QC_INSPECTOR,
  ROLES.REVIEWER,
];

const USER_PAGES = [
  generateUserRoute(APP_ROUTES.USER.LIST),
  generateUserRoute(APP_ROUTES.USER.ADD),
];

const PLANNING_PAGES = [
  generatePlanningRoute(APP_ROUTES.PLANNING.IMPORT),
  generatePlanningRoute(APP_ROUTES.PLANNING.PRODUCT),
  generatePlanningRoute(APP_ROUTES.PLANNING.TABLE),
  generatePlanningRoute(APP_ROUTES.PLANNING.PO_SELECTION),
  generatePlanningRoute(APP_ROUTES.PLANNING.SKIPPED_INSPECTIONS),
  generatePlanningRoute(APP_ROUTES.PLANNING.MANAGE_INSPECTIONS),
  generatePlanningRoute(APP_ROUTES.PLANNING.PACKAGING),
  generatePlanningRoute(APP_ROUTES.PLANNING.INSPECTION),
  generatePlanningRoute(APP_ROUTES.PLANNING.INSPECTION_DETAIL),
  generatePlanningRoute(APP_ROUTES.PLANNING.DOWNLOADS),
  generatePlanningRoute(APP_ROUTES.PLANNING.COMPLIANCE_DETAIL),
];

const INSPECTION_REPORT_DOWNLOAD_ROUTE = generatePlanningRoute(
  APP_ROUTES.PLANNING.INSPECTION_REPORT_DOWNLOAD
);

export const CLIENT_READONLY_ROLES = [
  ROLES.USER_ADMIN,
  ROLES.REGIONAL_DIRECTOR,
  ROLES.PLANNER,
  ROLES.REVIEWER,
];

export const ROLE_PERMISSIONS: Record<string, string[]> = {
  [ROLES.SYSTEM_ADMIN]: [
    ...REPORTING_PAGES,
    ...INSPECTOR_PERFORMANCE_PAGES,
    ...CLIENT_PAGES,
    ...USER_PAGES,
    ...PLANNING_PAGES,
    INSPECTION_REPORT_DOWNLOAD_ROUTE,
    ...(environment.useAutoPlanner ? [PLAN_V2_URL] : []),
  ],

  [ROLES.INSPECTOR]: [],

  [ROLES.ANALYST]: [...REPORTING_PAGES, INSPECTION_REPORT_DOWNLOAD_ROUTE],

  [ROLES.CUSTOMER]: [
    ...CUSTOMER_PAGES,
    APP_ROUTES.CLIENT.INSPECTIONS,
    INSPECTION_REPORT_DOWNLOAD_ROUTE,
  ],

  [ROLES.DECISION_EDITOR]: [APP_ROUTES.CLIENT.INSPECTIONS, INSPECTION_REPORT_DOWNLOAD_ROUTE],

  [ROLES.PLANNER]: [
    ...PLANNING_PAGES,
    INSPECTION_REPORT_DOWNLOAD_ROUTE,
    ...(environment.useAutoPlanner ? [PLAN_V2_URL] : []),
  ],

  [ROLES.TECHNICIAN]: [...CLIENT_PAGES, INSPECTION_REPORT_DOWNLOAD_ROUTE],

  [ROLES.REVIEWER]: [
    generatePlanningRoute(APP_ROUTES.PLANNING.MANAGE_INSPECTIONS),
    generatePlanningRoute(APP_ROUTES.PLANNING.INSPECTION_DETAIL),
    INSPECTION_REPORT_DOWNLOAD_ROUTE,
  ],

  [ROLES.BOOKING_REQUESTOR]: [INSPECTION_REPORT_DOWNLOAD_ROUTE],

  [ROLES.USER_ADMIN]: [...USER_PAGES, ...INSPECTOR_PERFORMANCE_PAGES],

  [ROLES.REGIONAL_DIRECTOR]: [
    ...USER_PAGES,
    ...REPORTING_PAGES,
    ...PLANNING_PAGES,
    ...CLIENT_PAGES,
    INSPECTION_REPORT_DOWNLOAD_ROUTE,
    ...(environment.useAutoPlanner ? [PLAN_V2_URL] : []),
  ],
};

export const TABLE = {
  COLS: {
    DECISION_TIME_TAKEN: 'decisionTimeTaken',
    SKIP_ADVICE: 'skipAdvice',
    CLIENT_DECISION: 'client_decision',
  },
};

export const INSPECTION_RESULT = {
  PASS: 'Pass',
};

const defaultPage = MENU.find((m: any) => {
  return m.default;
});

const getDefaultSubPage = (menu: any) => {
  return menu.pages.length === 1 ? menu.pages[0] : menu.pages.find((m: any) => m.default);
};
export const DEFAULT_PAGE = Object.keys(defaultPage).includes('pages')
  ? getDefaultSubPage(defaultPage).name
  : defaultPage.name.replaceAll(' ', '-');

export const INSPECTION_STATUS = {
  CLOSED: 'a2ed14f3-0b1c-4911-ba88-b8574bf2a37c',
  FINISHED: '8045cdc4-7824-4c62-af88-99afca20be85',
  CREATED: 'd34aecff-4a2b-4571-9cd3-c5fa0f0fc807',
  PAUSED: 'd64d9bc1-9c57-4e6e-a62e-cd4f2b67b9c7',
  PLANNED: 'fc97744b-89cf-4ee9-a21f-c3ec65e5533c',
  STARTED: '0723e131-d958-4623-8f3a-85055a0a7413',
};

export const INSPECTION_LEVELS = {
  POSITIVE_RELEASE: 4,
};

export const API_FILTERS = {
  TIMESTAMP_FIELD: {
    INSPECTION_DATE: 'inspectionDate',
    ENDTIME: 'endTime',
  },
  SORT_BY: {
    INSPECTION_DATE: 'inspectionDate',
    ENDTIME: 'endTime',
  },
};

export const LOGIN_ERROR_RESPONSE = {
  UNDER_REVIEW: {
    RESPONSE: 'Under Review',
    MESSAGE: 'Your account approval is pending',
  },
  PERMISSION_DENIED: {
    RESPONSE: 'Access Denied',
    MESSAGE:
      'We understand your request, but your current permissions don’t allow access to this page.',
  },
  SUSPENDED: {
    RESPONSE: 'Account Suspended',
    MESSAGE: 'Your account approval is pending',
  },
  LOCATION_REQUIRED: {
    RESPONSE: 'Location Required',
    MESSAGE:
      'Your role requires a location to be assigned. No location was found for your account. Please contact your administrator.',
  },
  INTERNAL_SERVER_ERROR: {
    RESPONSE: 'Internal Server Error',
    MESSAGE:
      'We’re currently experiencing a system issue and can’t process this action at the moment. Please contact Support for further assistance.',
  },
  EXCEPTION: {
    RESPONSE: 'Exception Error',
    MESSAGE:
      'Something went wrong while processing your request. Please try again, and if the problem continues, contact our Support team for help.',
  },
  DEFAULT: {
    RESPONSE: 'Login Error',
    MESSAGE: 'Unable to connect to the server!',
  },
};

export const HTTP_ERRORS = {
  CUSTOM_ERRORS: {
    FORBIDDEN_CODES: {
      UNDER_REVIEW: 'E403_001',
      PERMISSION_DENIED: 'E403_002',
    },
    LOCKED_CODES: {
      LOCATION_REQUIRED: 'E423_001',
    },
    EXCEPTION_CODES: {
      UNKNOWN_ERROR: 'E500_001',
    },
  },
};

export const PO_STATUS = {
  DEFAULT: 'OPEN',
  LIST_OPTIONS: [
    { name: 'All', value: 'ALL' },
    { name: 'Open', value: 'OPEN' },
    { name: 'Cancelled', value: 'CANCELLED' },
    { name: 'Closed', value: 'CLOSED' },
  ],
};

export const APIS = {
  // NEW ROUTES
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    POWER_BI: '/auth/powerbi/token',
    VALIDATE_TOKEN: '/auth/validate-token',
  },
  USERS: {
    BASE: '/users',
    MY_LOCATIONS: '/users/my-locations',
    MY_CONTROL_POINTS: '/users/my-control-points',
  },
  META: {
    TENANT_CENTRES: '/meta/tenant-centres',
    LOCATIONS: '/meta/locations',
    ROLES: '/meta/roles',
    CONTROL_POINTS: '/meta/control-points',
    SKIP_REASONS: '/meta/skip-reasons',
    INSPECTION_LEVELS: '/meta/inspection-levels',
    INSPECTION_RESULTS: '/meta/inspection-results',
    CLIENT_DECISIONS: '/meta/client-decisions',
    INSPECTION_STATUSES: '/meta/inspection-statuses',
    DIVISIONS: '/meta/divisions',
    DEFECTS_AND_SEVERITIES: '/meta/defects',
  },
  COMMON: {
    SUPPLIER: '/common/suppliers',
    SUPPLIER_BY_ID: '/common/suppliers/:id',
    DEPARTMENT: '/common/departments',
    PRODUCT_CATEGORY: '/common/product-categories',
    CUSTOMERS: '/common/customers',
    IS_TENANT_HAVE_CUSTOMER_USER: '/common/is-tenant-have-customer-user',
  },
  PRODUCTS: {
    BASE: '/products',
    SEARCH: '/products/search',
  },
  ORDERS: {
    GET_OR_CREATE: '/orders',
    PRODUCT_CATEGORIES: '/orders/product-categories',
    ADD_SKIP_REASON: '/orders/add-skip-reason',
  },
  INSPECTIONS: {
    SYNC: '/inspections/sync',
    BASE: '/inspections',
    IMPORT_FILE: '/inspections/import',
    UPDATE: '/inspections/:id',
    REPORT_VERSIONS: '/inspections/:id/versions',
    REPORT_VERSIONS_READ_URLS: '/inspections/:id/versions/read-urls',
    PDF_REPORT: '/inspections/:id/pdf',
    SHARE_REPORT: '/inspections/:id/share-report',
    CUSTOMERS: '/inspections/customers',
  },
  BOOKING_REQUESTS: {
    BASE: '/booking-requests',
    IMPORT_FILE: '/booking-requests/import',
  },
  INSPECTOR_MANAGEMENT: {
    INSPECTORS: '/inspector-management/inspectors',
  },
  SIZE_CHARTS: {
    INFO: '/size-charts/get-info',
    IMPORT_FILE: '/size-charts/import',
  },

  // OLD ROUTES
  GRAPH_ENDPOINT: 'https://graph.microsoft.com/v1.0/me',
  GET_COMPLINCE_CHECK_LIST: '/v1/complince_check_list', //
  ACCURACY_REPORT: '/v1/accuracy_report', //
  COMPLIANCE_REPORT: '/v1/compliance_report', //
  GARMENT_CHECK_REPORT: '/v1/garment_check_report', //
  UPDATE_AQL_INSPECTION: '/v1/aql_result', //
  COMPLIANCE_DETAILS: '/v1/compliance_report_detail', //
  UPDATE_COMPLIANCE: '/v1/Compliance_Report', //
};

export const USER_CONSTANTS = {
  PLATFORM: 2,
  ROLE: 5,
};

export const USER_DETAILS = {
  TOKEN: 'authToken',
  USER_ID: '_id',
  APPROVED: 'isApproved',
  ROLES: 'userRoles',
  NAME: 'name',
  LOCATION: 'location',
  LOCATIONS: 'locations',
  CURRENT_LOCATION: 'currentLocation',
  ID: 'id',
  EMAIL: 'email',
  TOKEN_EXPIRES_IN: 'expiresIn',
  IS_INTERNAL: 'isInternal',
};

export const TABLE_DATA = {
  USERS: [
    { name: 'NAME', key: 'name', case: 'normal', sort: true },
    { name: 'EMAIL', key: 'email', case: 'normal', sort: true },
    { name: 'ROLE', key: '_roleNames', case: 'normal' },
    { name: 'CUSTOMER', key: '_customerName', case: 'normal' },
    { name: 'SUPPLIER', key: '_supplierName', case: 'normal' },
    { name: 'LOCATION', key: '_locationName', case: 'normal' },
    { name: 'CONTROL POINTS', key: '_controlPoints', case: 'normal' },
    { name: 'APPROVAL', key: 'approved', case: 'approval-badge' },
  ],
  COMPLIANCE_PAN: [
    { name: 'COMP', key: 'compdata_select_for_compliance', case: 'select_unselect' },
    { name: 'Insp. Date', key: 'inspection_date', case: 'name' },
    { name: 'Loc.', type: 'number', key: 'UDC_id', case: 'normal' },
    { name: 'Insp.', key: 'inspection_number', case: 'normal' },
    { name: 'Supplier Name', key: 'supplier_name', case: 'name' },
    { name: 'Season', key: 'season_code', case: 'normal' },
    { name: 'PO Numbers', key: 'client_po', case: 'normal' },
    { name: 'Style', key: 'style_code', case: 'normal' },
    // { name: 'Description', key: 'description', case: 'normal' },
    { name: 'Colour', key: 'colour', case: 'normal' },
    { name: 'Booking Ref.', key: 'booking_reference', case: 'normal' },
    { name: 'Result', key: 'compliance_result', case: 'result' },
    { name: 'Carton Qty', type: 'number', key: 'carton_count', case: 'normal' },
    { name: 'Paper Tape', key: 'paper_tape', case: 'paper_tape_check' },
    { name: 'Total Units', type: 'number', key: 'actual_received_qty', case: 'normal' },
    { name: 'PO Qty', type: 'number', key: 'po_quantity', case: 'normal' },
    { name: 'Current Status', key: 'status_EN', case: 'normal' },
    { name: 'Inspector Name', key: 'Inspector', case: 'normal' },
    { name: 'Arrived', key: 'arrived_consol_date', case: 'normal' },
  ],
  COMPLIANCE_REPORT: [
    { name: 'Consol.', key: 'inspection_date', case: 'name' },
    { name: 'PO', key: 'UDC_id', case: 'normal' },
    { name: 'Line', key: 'inspection_number', case: 'normal' },
    { name: 'Date', key: 'supplier_name', case: 'normal' },
    { name: 'Supplier Name', key: 'season_code', case: 'name' },
    { name: 'Supplier Code', key: 'client_pos', case: 'normal' },
    { name: 'Total Ctns', type: 'number', key: 'style_code', case: 'normal' },
    { name: 'Description', key: 'style_name', case: 'normal' },
    { name: 'Total Qty.', type: 'number', key: 'colours', case: 'normal' },
    { name: 'PO Qty.', type: 'number', key: 'po_quantity', case: 'normal' },
  ],
  ACCURACY_REPORT: [
    // { name: 'Consol', key: 'UDC_id', case: 'normal' },
    { name: 'Client PO', key: 'client_po', case: 'normal' },
    { name: 'Consol. Centre', key: 'Consol_Centre', case: 'normal' },
    { name: 'PO', key: 'PO', case: 'normal' },
    { name: 'PO Line', key: 'PO_Line', case: 'normal' },
    { name: 'Date', key: 'Date', case: 'normal' },
    { name: 'Supplier Name', key: 'supplier_name', case: 'normal' },
    { name: 'Supplier Code', key: 'supplier_code', case: 'normal' },
    { name: 'Total Ctns', type: 'number', key: 'Total_Cartons', case: 'normal' },
    { name: 'Total Qty.', type: 'number', key: 'Total_Quantity', case: 'normal' },
    { name: 'Paper Tape', key: 'paper_tape', case: 'paper_tape_check' },
    { name: 'Carton No', type: 'number', key: 'Carton_Number', case: 'normal' },
    { name: 'Qty:Packing List', type: 'number', key: 'Qty_PackingList', case: 'normal' },
    { name: 'Qty: Carton Label', type: 'number', key: 'Qty_CartonLabel', case: 'normal' },
    { name: 'Qty: Unit Count', type: 'number', key: 'Qty_UnitCount', case: 'normal' },
    { name: 'PO Checked(%)', type: 'number', key: 'PercentagePOChecked', case: 'normal' },
    { name: 'Comments', key: 'Comments', case: 'normal' },
    { name: 'Rejected', key: 'Rejected', case: 'normal' },
  ],
  COMPLIANCE: [
    // { name: 'Consol', key: 'UDC_id', case: 'normal' },
    { name: 'Consol. Centre', key: 'Consol_Centre', case: 'normal' },
    // { name: 'Image Ref.', key: 'Image_Reference', case: 'link' },
    { name: 'Date', key: 'Date', case: 'normal', width: '50px' },
    { name: 'Supplier Name', key: 'supplier_name', case: 'normal' },
    { name: 'Supplier Code', key: 'supplier_code', case: 'normal' },
    { name: 'Booking Ref.', key: 'booking_reference', case: 'normal' },
    { name: 'PO', key: 'PO', case: 'normal' },
    { name: 'Style Code', key: 'style_sode', case: 'normal' },
    { name: 'Colour', key: 'colour', case: 'normal' },
    { name: 'Fault Description', key: 'Fault_Description', case: 'normal' },
    { name: 'Units', type: 'number', key: 'Units', case: 'normal' },
    { name: 'Cartons', type: 'number', key: 'Cartons', case: 'normal' },
    { name: 'Paper Tape', key: 'paper_tape', case: 'paper_tape_check' },
    { name: 'Comments', key: 'Comments', case: 'normal' },
    { name: 'Rejected', key: 'Rejected', case: 'normal' },
  ],
  GARMENT: [
    { name: 'Date', key: 'inspection_date', case: 'normal' },
    { name: 'Client PO', key: 'client_po', case: 'normal' },
    // { name: 'Consol', key: 'UDC_id', case: 'normal' },
    { name: 'Consol. Centre', key: 'Consol_Centre', case: 'normal' },
    { name: 'Country Of Origin', key: 'Country_of_Origin', case: 'normal' },
    { name: 'Origin Port', key: 'Origin_Port', case: 'normal' },
    { name: 'Supplier Code', key: 'supplier_code', case: 'normal' },
    { name: 'Supplier Name', key: 'supplier_name', case: 'name' },
    { name: 'Style Code', key: 'style_code', case: 'normal' },
    { name: 'Product Description', key: 'Product_Description', case: 'normal' },
    { name: 'Colour', key: 'colour', case: 'normal' },
    { name: 'Unit Height', key: 'Unit_Height', case: 'normal' },
    { name: 'Unit Length', key: 'Unit_Length', case: 'normal' },
    { name: 'Unit Width', key: 'Unit_Width', case: 'normal' },
    { name: 'Carton Height', key: 'carton_height', case: 'normal' },
    { name: 'Carton Length', key: 'carton_length', case: 'normal' },
    { name: 'Carton Width', key: 'carton_width', case: 'normal' },
    { name: 'Paper Tape', key: 'paper_tape', case: 'paper_tape_check' },
    { name: 'Status', key: 'Status', case: 'normal' },
    { name: 'Unit Volume', key: 'Unit_Volume', case: 'normal' },
    { name: 'Est UPC', key: 'Est_UPC', case: 'normal' },
    { name: 'SBS', key: 'SBS', case: 'normal' },
    { name: 'Difference(%)', key: 'PercDiff', case: 'normal' },
    { name: 'Suggested Issues', key: 'Suggested_Issue', case: 'normal' },
  ],
  ADMIN_PAGE: [
    { name: 'Client Name', key: 'name', case: 'normal' },
    { name: 'Visibility Portal', key: 'clientPage', case: 'link' },
    { name: 'Operations Portal', key: 'userPage', case: 'link' },
    // { name: 'Vendor Page', key: 'venderPage', case: 'link' },
  ],
};

export const DEFAULT_CONSTANTS = {
  SORT_DIRECTION: 1,
  SORT_KEY: 'firstName',
  // INSP_TYPE: 'DCInsp'
  INSP_TYPE: 'DC Inspection',
};

export const API_KEYS = {
  SORT_DIRECTION: 'sortOrder',
  SORT_KEY: 'sortKey',
  FILTER_KEY: 'filterKey',
  FILTER_VALUE: 'filterValue',
  SEARCH: 'search',
};

export const MESSAGES = {
  DIALOGUE_BOX: {
    DELETE_USER: 'Are you sure you want to delete this user?',
    DELETE_INSPECTION: 'Are you sure you want to delete this inspection?',
    UPDATE_CLIENT_DECISION: 'Are you sure you want to update client decision to {dec} ?',
  },
  ERRORS: {
    USER: {
      FETCH: 'Unable to fetch users',
      UPDATE: 'Unable to update user',
      DELETE: 'Unable to delete user',
    },
    ORDERS: {
      FETCH: 'Unable to fetch orders',
    },
    SKIPPED_INSPECTIONS: {
      FETCH: 'Unable to fetch skipped inspections',
    },
    INSPECTIONS: {
      CREATE: 'Unable to create inspections',
      FETCH: 'Unable to fetch inspections',
      CLIENT_DECISIONS: 'Unable to update client decision',
    },
    FILTERS: {
      INVALID_DATE_RANGE: 'Invalid date range!',
    },
    SKIPPED_ORDERS: {
      FETCH: 'Unable to fetch skipped inspections',
      UPDATE: 'Unable to update skip reason',
    },
    INVALID_GROUPING: {
      MAX_STYLE_CODES_EXCEEDED: 'Cannot group more than two style codes.',
      UNKNOWN_PRODUCT_CATEGORY: 'Cannot group with unknown product category',
      UNKNOWN_SEASON_CODE: 'Cannot group with unknown season code',
      ON_SUBMIT: {
        PRODUCT_CATEGORY_MISMATCH_ERROR: 'Cannot group different product categories.',
        SEASON_CODE_MISMATCH_ERROR: 'Cannot group different season codes.',
        EXACT_TWO_STYLES_REQUIRED: 'Can group exactly 2 styles',
      },
    },
    INSPECTION: {
      CREATE: 'Unable to create inspection',
      UPDATE: 'Unable to update inspection',
      DELETE: 'Unable to delete inspection',
      GET: 'Unable get inspection details',
      INVALID_ID: 'Invalid inspection id',
      RESULT: 'Unable to update result',
    },
    PRODUCT: {
      ADD: 'Unable to add product',
      UPDATE: 'Unable to update product',
      SELECT: 'Please select a valid product',
      DELETE: 'Unable to delete product',
      SAMPLE_REC_DATE_UPDATE: 'Unable to update sample received date.',
    },
    SIZE_CHARTS: {
      UPLOAD_FAILED: 'Unable to upload size chart file',
      NO_FILE_SELECTED: 'No file selected',
      GET_INFO: 'Unable to get size chart info',
    },
    BOOKING_REQUESTS: {
      CREATE: 'Unable to create booking requests',
      IMPORT: 'Unable to import booking requests',
      FETCH: 'Unable to fetch booking requests',
      UPDATE: 'Unable to update booking request',
    },

    INVALID_INSPECTION_TYPE: 'Invalid inspection type',
    RequireValidation: 'This field is required.',
    MinLengthBillBoardValidation: 'At least 10 characters are required.',
    BlockUser: 'Are you sure you want to block this user?',
    ResetPoints: 'Are you sure you want to reset this user?',
    ResetGold: 'Are you sure to reset the gold of this user?',
    UnblockUser: 'Are you sure you want to unblock this user?',
    RestoreUser: 'Are you sure you want to restore this user?',
    UnauthorizedUser: 'Unauthorized User',
    FailedToAddStyle: 'This style cannot be added.',
    FailedToAddUser: 'User cannot be added.',
    YourAccountNotApproved: 'Your access is awaiting approval.',
    CompletedSizeChartNotFound: 'Completed size chart cannot be found.',
    FailedToLoadReport: 'Failed to Load Report.',
    FailedToUploadFile: 'File upload Failed!',
    FailedToLoadInspectionReportVersion: 'File to Load Inspection Report Versions!',
    FailedToFetchLocations: 'Failed to fetch locations.',
    FailedToFetchRoles: 'Failed to fetch roles.',
    FailedToAddInspections: 'failed to add Inspections.',
    FailedToUpdateDeliveryQuantity: 'Failed to update delivery quantity.',
    FailedToUpdateSubmissionNumber: 'Failed to update Submission Number.',
    INTERNAL_SERVER_ERROR: 'Internal server error.',
    NoChangeDetected: 'No changes detected.',
    FailedToUpdateInspection: 'Failed to update Inspection!',
  },
  SUCCESS: {
    INSPECTION: {
      CREATE: 'Inspection created',
      UPDATE: 'Inspection updated',
      DELETE: 'Inspection deleted',
      CLIENT_DECISIONS: 'Client decision updated successfully.',
      RESULT: 'Result updated',
    },
    SIZE_CHARTS: {
      UPLOAD_SUCCESS: 'Size chart uploaded successfully.',
    },
    BOOKING_REQUESTS: {
      CREATE: 'Booking requests created successfully',
      IMPORT: 'Booking requests imported successfully',
      UPDATE: 'Booking request updated successfully',
    },
    PRODUCT: {
      CREATED: 'Product added successfully.',
      UPDATED: 'Product updated successfully.',
      DELETED: 'Product deleted successfully.',
      SAMPLE_REC_DATE_UPDATE: 'Sample received date updated successfully.',
    },
    UserUpdated: 'User updated successfully',
    Unblocked: 'User unblocked successfully.',
    StyleAdded: 'Style added successfully.',
    UserAddedSuccessfully: 'User added successfully.',
    POQtyUpdatedSuccesfully: 'PO quantity updated successfully.',
    ResultUpdatedSuccesfully: 'Result updated Successfully.',
    FileUploadedSuccess: 'File uploaded successfully.',
    UserPlatformUpdated: 'User platform updated successfully.',
    UserRoleUpdated: 'User Role updated successfully.',
    UserLocationUpdated: 'User location updated successfully.',
    UserApproved: 'User approved successfully.',
    UserBlocked: 'User blocked successfully.',
    UserDeleted: 'User deleted successfully.',
    RecordUpdated: 'Record updated successfully.',
    TotalUnits: 'Total Units Updated Successfully.',
    InspectionsAdded: 'Inspections added successfully.',
    DeliveryQtyUpdatedSuccessfully: 'Delivery quantity updated successfully.',
    SubmissionNumberUpdatedSuccessfully: 'Submission Number updated successfully.',
    SuccessUpdateInspection: 'Successfully updated Inspection!',
  },
  TITLES: {
    skippedInspections: 'Skipped Inspections',
    AddStyle: 'Add New Style',
    CreateUser: 'Create User',
    InspectionReports: 'Inspection Reports',
    GarmentDimensions: 'Garment Dimensions',
    CartonCheck: 'Carton Check',
    CartonPhotoThumbnails: 'Carton Photo Thumbnails',
    Accuracy: 'Accuracy',
    Compliance: 'Compliance',
    GarmentCheck: 'Garment Check',
    MaxAllowedDefects: 'Maximum Allowed Defects',
    SampleQtyMaxAllowableDefects: 'Sample Quantity - Maximum Allowable Defects',
    DefectsFound: 'Defects Found',
    PhotoThumbnails: 'Photo Thumbnails',
    FullProductImage: 'Full Product Image',
    Upload: 'Upload',
  },
  LABELS: {
    poStatus: 'Order Status',
    productCode: 'Product Code',
    productName: 'Product Name',
    productCategoryName: 'Product Category Name',
    productCategoryCode: 'Product Category Code',
    departmentCode: 'Department Code',
    departmentName: 'Department Name',
    color: 'Colour',
    colorCode: 'Colour Code',
    status: 'Status',
    inspector: 'Inspector',
    groupBy: 'Group By',
    StyleCode: 'Style Code',
    ProductCode: 'Product Code',
    ProductType: 'Product Type',
    UserName: 'User Name',
    Email: 'Email',
    Role: 'Role',
    Platform: 'Platform',
    Location: 'Location',
    ConsolCentre: 'Consol. Centre',
    Division: 'Division',
    Department: 'Department',
    Date: 'Date',
    Result: 'Result',
    Supplier: 'Supplier',
    StyleName: 'Style Name',
    PoNos: `PO/NO's`,
    Quantity: 'Quantity',
    Cartons: 'Cartons',
    InspectionDate: 'Inspection Date',
    InspectionType: 'Inspection Type',
    ControlPoint: 'Control Point',
    skipReason: 'Skip Reason',
    SupplierName: 'Supplier Name',
    PONumber: 'PO Number',
    InternalOrderRef: 'Internal Order Ref.',
    Colour: 'Colour',
    Length: 'Length',
    Breadth: 'Breadth',
    Height: 'Height',
    Weight: 'Weight',
    CartonNo: 'Ctn No',
    PLQty: 'P/L Qty',
    LabelQty: 'Label Qty',
    ActualQty: 'Actual Qty',
    CtnHeight: 'Ctn Height',
    CtnLength: 'Ctn Length',
    CtnWidth: 'Ctn Width',
    FaultFound: 'Fault Found',
    Description: 'Description',
    TotalPoQty: 'Total PO Qty.',
    TotalInspQty: 'Total Inspection Qty.',
    OrderSize: 'Order Size',
    Season: 'Season',
    Submission: 'Submission',
    InspLevel: 'Inspection Level',
    SampleQty: 'Sample Qty.',
    Minor: 'Minor',
    Major: 'Major',
    Critical: 'Critical',
    QtyRemoved: 'Quantity removed',
    Inspector: 'Inspector',
    TotalDefects: 'Total Defects',
    Code: 'Code',
    DefectDesc: 'Defect Description',
    ArrivedDate: 'Arrived Date',
    LastUpdated: 'Last updated',
    TotalUnits: 'Total Units',
    PendingDecisions: 'Pending Decisions',
    SampleReceivedOn: 'All Sample Received On',
    Retailer: 'Retailer',
  },
  BUTTONS: {
    Add: 'Add',
    Cancel: 'Cancel',
    Update: 'Update',
    Logout: 'Logout',
    ApplyFilters: 'Apply filters',
    ClearFilters: 'Clear filters',
    Download: 'Download',
    SaveUpload: 'Save and Upload',
    DeleteStyleCode: 'Delete Style Code',
    Edit: 'Edit',
  },
};

export const DEFECT_FILTERS = {
  CONTROL_POINT: 'controlPointId',
  DIVISION: 'divisionId',
};

export const INSPECTION_RESULTS = ['Pass', 'Fail', 'Pending', 'Comm. Pass'];

export const CLIENT_DECISIONS = {
  UNDER_REVIEW: 'Under Review',
  FAIL_UNDER_REVIEW: 'Fail - Under Review',
};

export const INSPECTION_TYPES = {
  DC_ORIGIN_INSPECTION: 'DC Origin Inspection',
  UK_DC_INSPECTION: 'UK DC Inspection',
};

export const ROWS_PER_PAGE_OPTIONS = [
  { text: '10', value: 10 },
  { text: '50', value: 50 },
  { text: '100', value: 100 },
  { text: '200', value: 200 },
  { text: '500', value: 500 },
];

export const SELECTED_ROWS_PER_PAGE = 10;

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  LIMIT_OPTIONS: [10, 20, 50, 100, 200, 500],
};
